export default __webpack_public_path__ + "a08549acaa028133fb52ed32de6d477b.svg";